import { MiqSavable, MiqSavableType } from './savable';
import { MiqTouchable, MiqTouchableType } from './touchable';
import { MiqValidatable, MiqValidatableType } from './validatable';

export const enum MiqRegisteredBehaviorType {
  Validatable = 'MiqValidatableBehavior',
  Savable = 'MiqSavableBehavior',
  Touchable = 'MiqTouchableBehavior',
}

export const MiqRegisteredBehaviors = new Map<MiqRegisteredBehaviorType, any>([
  [MiqRegisteredBehaviorType.Validatable, MiqValidatableType],
  [MiqRegisteredBehaviorType.Savable, MiqSavableType],
  [MiqRegisteredBehaviorType.Touchable, MiqTouchableType],
]);

export abstract class MiqBehaviors implements Partial<MiqValidatable>, Partial<MiqSavable>, Partial<MiqTouchable> {}
